import React from 'react';
import {renderRichText} from "gatsby-source-contentful/rich-text";
import {getImage} from "../../contentful/data-provider";
import {Link} from "../../../.cache/gatsby-browser-entry";

function BenefitsSection(props) {
    const content = props.content;
    return (
        <section className="benefits-section">
            <div className="container">
                <div className="row justify-content-lg-between align-items-lg-center mb-5">
                    <div className="col-12 col-lg-8">
                        <h2>{content.title}</h2>
                    </div>
                    <div className="col-12 col-lg-4 text-lg-right"/>
                </div>
                <div className="row">
                    { content.elements.map((element, index) => {
                        return (
                            <div className="col-12 col-sm-6 col-md-4">
                                <div className="benefit-col">
                                    <div className="image">
                                        <img src={getImage(element.image).url} alt={getImage(element.image).title} className="mx-auto mx-md-0"/>
                                    </div>
                                    <h6>{element.title}</h6>
                                    {element.body && renderRichText(element.body)}
                                </div>
                            </div>
                        );
                    }) }
                </div>
                { (content.ctaText && content.ctaUrl) &&
                    <div className="row actions">
                        <div className="col-lg-12">
                            <Link className="btn" to={content.ctaUrl}>
                                {content.ctaText}
                            </Link>
                        </div>
                    </div>
                }
            </div>
        </section>
    );
}

export default BenefitsSection;
